import { useContext, useState } from 'react';
import {
  Banner,
  Bullets,
  FlexContainer,
  Inputs,
  ModalContext,
  Modals,
  Sizes,
  Text,
} from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { useAutoRenewal } from 'Containers/Filing/hooks';
import * as Styled from './styles';

const AutoRenewalModal = (): JSX.Element => {
  const { mutate: autoRenewal } = useAutoRenewal();
  const { t } = useTranslation(locizeNS.RESULT);
  const [isActive, setIsActive] = useState(true);
  const { hideModal } = useContext(ModalContext);

  const handleClickModal = (): void => {
    autoRenewal({ isAutoRenewalEnabled: isActive });
    hideModal();
  };

  const handleChange = (): void => {
    setIsActive(!isActive);
  };

  return (
    <Modals.Centered
      maxSize="S"
      hasClose={false}
      onClose={hideModal}
      buttonsAlign="center"
      title={t('AutoRenewal.title')}
      primaryButton={{
        label: t('AutoRenewal.button'),
        onClick: handleClickModal,
      }}
    >
      <Styled.ModalContent direction="column" gap="dimension_16">
        <Text align="center" type="paragraphs" size="M_L_S" color="fresh">
          {t('AutoRenewal.subtitle')}
        </Text>
        <Bullets
          bullets={[
            {
              text: t('AutoRenewal.info.first'),
            },
            {
              text: t('AutoRenewal.info.second'),
            },
          ]}
          icon={{
            height: 16,
            type: 'IconTickCleanSGreen',
            width: 16,
          }}
          spacing="M"
        />
        <FlexContainer direction="column" gap="dimension_08">
          <Styled.SwitcherContainer align="center" gap="dimension_08">
            <Text type="paragraphs" color="dark" size="S_L_S" align="start">
              {t('AutoRenewal.info.switch')}
            </Text>
            <Inputs.Switcher value={isActive} onChange={handleChange} />
          </Styled.SwitcherContainer>
          {isActive ? (
            <Text type="paragraphs" color="grey" size="XS_S_S">
              {t('AutoRenewal.info.switch.description')}
            </Text>
          ) : (
            <Banner
              id="years-banner"
              mode="warning"
              layout="embed"
              position="horizontally"
              label={t('AutoRenewal.info.switch.off')}
              size={Sizes.S}
            />
          )}
        </FlexContainer>
      </Styled.ModalContent>
    </Modals.Centered>
  );
};

export default AutoRenewalModal;
